export class SiteAnnualgradeTrendModel {   
    Grade : string;
    MeasurementYear : number;

    constructor(measurementYear : number,
        grade : string)
    {
        this.MeasurementYear = measurementYear;
        this.Grade = grade;
    }
}
